import React from 'react'
import { useFormContext } from 'react-hook-form'
import { DevTool, PLACEMENT } from '@hookform/devtools'

interface Props {
    placement?: PLACEMENT
}

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname)

export const RhfDevTool: React.VFC<Props> = ({ placement = 'bottom-right' }: Props) => {
    const disabled = !isLocalHost
    const { control } = useFormContext() || {}

    if (disabled) {
        return <div />
    }

    if (!control) {
        console.error('Did you place `<RhfDevTools />` as a child of a Rhf `<FormProvider />` component?')
        return <div />
    }

    return <DevTool control={control} placement={placement} />
}

export type { Props as RhfDevToolProps }
